/* Lilla Guldfågeln: the category filters (snippets/lg-filters.liquid).
   Every change re-renders the section through Shopify's Section Rendering API (?section_id=) and swaps in the
   filters, chips, count and results, so the page never reloads; the address keeps the filters (shareable, back works).
   Desktop: one panel open at a time, closed by a click outside or Esc. Phone: "Filtrera" opens the groups as a
   drawer; its button shows the new count and just closes the drawer. Without this script the form still submits. */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const form = () => $('#lgf');
  if (!form()) return;
  const mob = matchMedia('(max-width: 760px)');
  let busy = null, timer = 0;

  // the form as a query: empty prices left out, a quick price range written into the from/to fields
  function query(f) {
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(f)) if (k !== 'lgf-range' && v !== '') p.append(k, v);
    return p;
  }

  async function load(url, push = true) {
    const sec = form().dataset.section, u = new URL(url, location.href);
    u.searchParams.delete('page');
    const fetchURL = new URL(u); fetchURL.searchParams.set('section_id', sec);
    if (busy) busy.abort(); busy = new AbortController();
    const res = $('#lgr'); if (res) res.setAttribute('aria-busy', 'true');
    let html;
    try { html = await (await fetch(fetchURL, { signal: busy.signal })).text() } catch (e) { if (e.name !== 'AbortError') location.href = u; return }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    // keep open what was open (the pill or the drawer's accordions) and where the drawer was scrolled
    const open = $$('#lgf details[open]').map(d => d.dataset.g), drawer = document.body.classList.contains('lgf-on');
    const scroll = ($('.lgf-groups') || {}).scrollTop || 0;
    for (const id of ['lgf', 'lgf-chips', 'lgr', 'lgcount']) { const a = document.getElementById(id), b = doc.getElementById(id); if (a && b) a.replaceWith(b) }
    $$('#lgf details').forEach(d => { if (open.includes(d.dataset.g)) d.open = true });
    if (drawer) { const g = $('.lgf-groups'); if (g) g.scrollTop = scroll; $('[data-lgf-open]').setAttribute('aria-expanded', 'true') }
    const desc = $('.coll-desc'); if (desc) desc.hidden = [...u.searchParams.keys()].some(k => k.startsWith('filter.'));
    if (push) history.pushState({ lgf: 1 }, '', u.pathname + u.search);
    bind();
    if (window.LG && LG.hydrate) LG.hydrate($('#lgr'));
  }

  function submit(delay = 0) {
    clearTimeout(timer);
    timer = setTimeout(() => load(form().action + '?' + query(form()).toString()), delay);
  }

  function bind() {
    const f = form();
    f.addEventListener('change', e => {
      const t = e.target;
      if (t.matches('[data-range]')) {               // a quick price range fills the from/to fields
        const [lo, hi] = t.value.split('-'), [a, b] = $$('[data-price]', f);
        a.value = lo === '0' ? '' : lo; b.value = hi || '';
      } else if (t.matches('[data-price]')) $$('[data-range]', f).forEach(r => r.checked = false);
      submit(t.matches('[data-price]') ? 400 : 0);
    });
    f.addEventListener('submit', e => { e.preventDefault(); submit() });
    $$('details.fg', f).forEach(d => d.addEventListener('toggle', () => {
      if (d.open && !mob.matches) $$('details.fg[open]', f).forEach(o => { if (o !== d) o.open = false });
    }));
    const btn = $('[data-lgf-open]', f);
    if (btn) btn.addEventListener('click', () => setDrawer(true));
    $$('[data-lgf-close]', f).forEach(b => b.addEventListener('click', () => setDrawer(false)));
    // a panel's "Visa N produkter" just closes it: the results are already there
    $$('[data-lgf-done]', f).forEach(b => b.addEventListener('click', () => { const d = b.closest('details'); d.open = false; d.querySelector('summary').focus() }));
  }

  function setDrawer(on) {
    document.body.classList.toggle('lgf-on', on);
    const b = $('[data-lgf-open]'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) { const first = $('.lgf-panel summary'); if (first) first.focus() }
  }

  // chips, "Rensa alla" and the empty state's link load in place too
  document.addEventListener('click', e => {
    const a = e.target.closest('a[data-lgf-link]');
    if (a && !e.metaKey && !e.ctrlKey) { e.preventDefault(); load(a.href); return }
    // a click outside closes the open pill panel (desktop) or the drawer's backdrop (phone)
    if (!e.target.closest('#lgf')) {
      if (!mob.matches) $$('#lgf details.fg[open]').forEach(d => d.open = false);
    } else if (e.target.classList.contains('lgf-panel') && mob.matches) setDrawer(false);
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const o = $('#lgf details.fg[open]');
    if (o && !mob.matches) { o.open = false; o.querySelector('summary').focus() } else if (document.body.classList.contains('lgf-on')) setDrawer(false);
  });
  addEventListener('popstate', () => load(location.href, false));
  mob.addEventListener('change', () => { setDrawer(false); $$('#lgf details.fg[open]').forEach(d => d.open = false) });
  bind();
})();
